import { IRLogo } from "components/common/Icons/IRLogo";
import type { ReactNode } from "react";
import { DesktopNavigation } from "../DesktopNavigation/DesktopNavigation";
import { MobileNavigation } from "../MobileNavigation/MobileNavigation";
import type { LanguageProps } from "components/modules/Layout/Footer/Footer";

export interface EditorNavbarProps extends LanguageProps {
    actionButton?: ReactNode;
}

export const EditorNavbar = ({ actionButton, url, urlSlugVariables }: EditorNavbarProps) => {
    return (
        <div className="flex min-w-0 border-b-slate-200 dark:border-b-darkSurface-600 border-b flex-row items-center h-16 px-4 md:px-8 py-4 dark:bg-darkSurface-100">
            <div className="mx-4 lg:hidden">
                <MobileNavigation isEditor={true} url={url} urlSlugVariables={urlSlugVariables} />
            </div>
            <IRLogo isEditor={true} />
            <div className='mr-16'></div>
            <div className="ml-auto lg:hidden">{actionButton}</div>
            <DesktopNavigation isEditor={true} />
        </div>
    );
};
